import { toRGBA } from "./utils";

const astro = [200, 200, 200];
const a = (opacity: number = 1) =>
  toRGBA(astro[0], astro[1], astro[2], opacity);

export default a;
